import React from 'react';
import { useLanguage } from '../context/LanguageContext';

function About() {
  const { t } = useLanguage();

  return (
    <section id="about">
      <div className="container">
        <h2 className="section-title">{t.about.title}</h2>
        <div className="about-content">
          <p className="about-text">
            {t.about.intro}
            <br /><br />
            {t.about.subIntro}
          </p>

          <div className="mission-focus" style={{textAlign: "center", marginBottom: '0px'}}>
                <h3 style={{marginBottom: '0px'}}>{t.about.principlesTitle}</h3></div>
          
          <div className="jkd-principles">
            {t.about.principles.map((principle, index) => (
              <div className="principle-card" key={index}>
                <h3>{principle.title}</h3>
                <p>{principle.text}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default About;
